import React, { lazy } from "react";
import Layout from "components/presentation/main/layout/Layout";
import Main from "components/presentation/main/Main";
import Chat from "components/tmisc/chat/Chat";
import "styles/css/presentation/Presentation.css";

const Studio = lazy(() => import("components/studio/Studio"));
const Settings = lazy(() => import("components/presentation/sections/settings/Settings"));
const History = lazy(() => import("components/presentation/sections/history/History"));
const Collections = lazy(() => import("components/collections/Collections"));
const Permissions = lazy(() => import("components/presentation/sections/permissions/Permissions"));
const TestCases = lazy(() => import("components/studio/board/forms/tests_cases/TestCases"));
const Versions = lazy(() => import("components/presentation/sections/versions/Versions"));
const Licenses = lazy(() => import("components/presentation/sections/licenses/Licenses"));
const Brief = lazy(() => import("components/brief/Brief"));

const PresentationSection = (props) => {
  const {
    flow,
    userRole,
    isAdmin,
    showManageCollections,
    refreshFlow,
    refreshChat,
    onClickTab,
  } = props;

  const components = {
    "main": {
      "component": Main,
      "background": "ANIMATED",
      "props": {}
    },
     "brief": {
      "component": Brief,
      "background": "ANIMATED",
      "isLazy": true,
      "props": {
        flow,
        refetchProject: refreshFlow,
      }
    },
    "agent": {
      "component": Chat,
      "background": "ANIMATED",
      "props": {
        flow,
        onClickTab,
      }
    },
    "processes": {
      "component": Studio,
      "background": "NONE",
      "isLazy": true,
      "props": {
        match: { params: { flowId: flow.id } }
      }
    },
    "data": {
      "component": Collections,
      "background": "NONE",
      "isLazy": true,
      "props": {
        flow: flow,
        userRole,
        isAdmin,
        showManageCollections,
      }
    },
    "history": {
      "component": History,
      "background": "ANIMATED",
      "isLazy": true,
      "props": {
        flow,
        isAdmin,
        onClickTab,
      }
    },
    "settings": {
      "component": Settings,
      "background": "CARD",
      "isLazy": true,
      "props": {
        flow,
        refreshFlow,
        refreshChat,
        isAdmin,
      }
    },
    "versions": {
      "component": Versions,
      "background": "CARD",
      "isLazy": true,
      "props": {
        flow
      }
    },
    "permissions": {
      "component": Permissions,
      "background": "CARD",
      "isLazy": true,
      "props": {
        flow,
        refreshFlow,
        isAdmin,
      }
    },
    "licenses": {
      "component": Licenses,
      "background": "CARD",
      "isLazy": true,
      "props": {
        flow,
      }
    },
    "test_cases": {
      "component": TestCases,
      "background": "CARD",
      "isLazy": true,
      "props": {
        flow,
      }
    }
  };

  return <Layout
    {...props}
    components={components}
  />;

}

export default PresentationSection;
